export const CLARET = '#8f1537';
